const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL,
  // PREFIX: process.env.REACT_APP_API_PREFIX || '/api',
  TIMEOUT: 10000
};

export const API_URL = `${API_CONFIG.BASE_URL}`; // ${API_CONFIG.PREFIX}

export default API_CONFIG;